import type { Locale } from './types';

export const SUPPORTED_LOCALES = ['en', 'zh-CN'] as const satisfies readonly Locale[];

export const DEFAULT_LOCALE: Locale = 'en';
